import { create } from 'zustand'

import type { Hub } from '@/services/schemas'
import { $data } from '@/stores/Data'
import { CONTROL_HUB_IDS, DELUXE_HUBS_IDS } from '@/util/Hardcoded'

export type HubType = 'control' | 'deluxe'

type HubStore = {
  hubs: Hub[]
  originalHubs: Hub[]

  initialize: () => void
  setHubs: (hubs: Hub[]) => void
  setOriginalHubs: (hubs: Hub[]) => void
  resetHubs: () => void
  filterHubs: (type: HubType) => void
}

const useHubStore = create<HubStore>()((set, get) => ({
  hubs: [],
  originalHubs: [],

  initialize: () => {
    const data = $data.get()!.hubs
    return set({
      hubs: data,
      originalHubs: data,
    })
  },
  setHubs: hubs => set({ hubs }),
  setOriginalHubs: hubs => set({ originalHubs: hubs }),
  resetHubs: () => set({ hubs: get().originalHubs }),
  filterHubs: (type: HubType) => set({
    hubs: get().originalHubs.filter(hub => type === 'deluxe' ? DELUXE_HUBS_IDS.includes(hub.id) : CONTROL_HUB_IDS.includes(hub.id)),
  }),
}))

export { useHubStore }
